<template>
  <div>
    <v-row style="padding-top: 3px">
      <v-col>
        <v-btn
          v-if="!letterDetails.orderId && !letterDetails.orderCode"
          :class="color + '-mainBtn'"
          class="w-100"
          height="40"
          @click="openDialog()"
          >انتخاب کد استعلام مرتبط با نامه</v-btn
        >
        <div v-else class="d-flex justify-space-between">
          <div class="mt-2">
            <span class="grey-color">استعلام مرتبط با نامه: </span>
            <span class="h6 font-weight-bold dark-grey-color">
              <span v-if="letterDetails.orderId.length && allCodes.length">
                {{
                  allCodes.filter((x) => x.id == letterDetails.orderId)[0].code
                }}
              </span>
              <span v-else-if="letterDetails.orderCode.length">
                {{ letterDetails.orderCode }}
              </span>
            </span>
          </div>

          <div class="float-end">
            <v-btn
              width="95"
              :class="color + '-borderedBtn'"
              @click="openDialog()"
            >
              ویرایش</v-btn
            >
            <v-btn
              class="ms-2 red-mainBtn white--text"
              width="90"
              @click="
                letterDetails.orderId = '';
                letterDetails.orderCode = '';
                $emit('getId', letterDetails.orderId);
              "
            >
              حذف</v-btn
            >
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="chooseCustomerDialog" width="600">
      <v-card class="dash-modal-card" style="overflow-y: auto !important">
        <v-window v-model="step">
          <v-window-item :value="1">
            <v-row>
              <v-col class="pt-4">
                <h5 class="mt-1 grey-color">انتخاب شرکت</h5>
              </v-col>
              <v-col class="text-left">
                <div :class="color + '-input'">
                  <v-text-field
                    class="float-left"
                    v-model="search"
                    outlined
                    dense
                    placeholder="جستجو"
                  >
                    <template #prepend-inner>
                      <v-icon> $Magnify </v-icon>
                    </template>
                    <template v-if="search.length" #append>
                      <v-icon @click="search = ''"> $Close </v-icon>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-card-text style="height: 450px">
              <v-row class="mb-4">
                <v-col class="pt-4">
                  <span class="grey-color"
                    >ابتدا شرکت مورد نظر را از لیست زیر انتخاب نمایید:</span
                  >
                </v-col>
              </v-row>

              <div
                v-if="search.length && !computedCustomers.length"
                class="text-center h5 pa-3"
              >
                نتیجه‌ای برای "{{ search }}" یافت نشد.
              </div>
              <div v-else class="users mt-1">
                <div class="px-3">
                  <div class="custom-table">
                    <b-table
                      responsive
                      show-empty
                      stacked="sm"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :items="computedCustomers"
                      :fields="customersFields"
                      empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      striped
                      thead-class="headClass"
                      :tbody-class="color + '-trClass'"
                      :busy="gettingCustomrs"
                    >
                      <template v-slot:cell(index)="data">
                        <div
                          style="text-align: center; vertical-align: middle"
                          class="pt-0"
                        >
                          {{ data.index + 1 + perPage * (currentPage - 1) }}
                        </div>
                      </template>
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div
                          style="text-align: center; vertical-align: middle"
                          class="pt-0 grey-color"
                        >
                          <div class="mt-2">{{ data.value }}</div>
                        </div>
                      </template>
                      <template v-slot:cell(name)="data">
                        <div
                          style="text-align: center; vertical-align: middle"
                          class="pt-0 grey-color"
                        >
                          <div class="mt-2">
                            {{ data.item.name }}
                          </div>
                        </div>
                      </template>

                      <template v-slot:cell(operation)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <v-btn
                            v-if="selectedCustomer != data.item"
                            @click="selectedCustomer = data.item"
                            height="40"
                            width="80"
                            :class="color + '-mainBtn'"
                            >انتخاب</v-btn
                          >
                          <v-btn
                            v-if="selectedCustomer == data.item"
                            @click="selectedCustomer = ''"
                            height="40"
                            class="red-mainBtn"
                            width="80"
                            >حذف</v-btn
                          >
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong>در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                    <div
                      class="d-flex flex-row justify-content-end"
                      :class="color + '-custom-pagination'"
                    >
                      <v-pagination
                        v-model="currentPage"
                        :length="Math.ceil(computedCustomers.length / perPage)"
                        :total-visible="5"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                      ></v-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="px-0">
              <v-btn
                @click="nextStep()"
                width="130"
                height="40"
                class="mt-6 float-start"
                :class="color + '-mainBtn'"
                :disabled="!selectedCustomer.name"
                >انتخاب کد استعلام</v-btn
              >

              <v-spacer></v-spacer>
              <v-btn
                @click="chooseCustomerDialog = false"
                width="130"
                height="40"
                class="red-borderedBtn mt-6"
                >بستن</v-btn
              >
            </v-card-actions>
          </v-window-item>
          <v-window-item :value="2">
            <v-row>
              <v-col class="pt-4">
                <h5 class="mt-1 grey-color">انتخاب کد استعلام</h5>
              </v-col>
              <v-col class="text-left">
                <div :class="color + '-input'">
                  <v-text-field
                    class="float-left"
                    v-model="search"
                    outlined
                    dense
                    placeholder="جستجو"
                  >
                    <template #prepend-inner>
                      <v-icon> $Magnify </v-icon>
                    </template>
                    <template v-if="search.length" #append>
                      <v-icon @click="search = ''"> $Close </v-icon>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-card-text style="height: 450px">
              <v-row class="mb-4">
                <v-col class="pt-4">
                  <span class="grey-color"
                    >کد استعلام مورد نظر را از لیست زیر انتخاب نمایید:</span
                  >
                </v-col>
              </v-row>

              <div
                v-if="search.length && !computedCodes.length"
                class="text-center h5 pa-3"
              >
                نتیجه‌ای برای "{{ search }}" یافت نشد.
              </div>
              <div v-else class="users mt-1">
                <div class="px-3">
                  <div class="custom-table">
                    <b-table
                      responsive
                      show-empty
                      stacked="sm"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :items="computedCodes"
                      :fields="codesFields"
                      empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      striped
                      thead-class="headClass"
                      :tbody-class="color + '-trClass'"
                      :busy="gettingCodes"
                    >
                      <template v-slot:cell(index)="data">
                        <div
                          style="text-align: center; vertical-align: middle"
                          class="pt-0"
                        >
                          {{ data.index + 1 + perPage * (currentPage - 1) }}
                        </div>
                      </template>
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div
                          style="text-align: center; vertical-align: middle"
                          class="pt-0 grey-color"
                        >
                          <div class="mt-2">{{ data.value }}</div>
                        </div>
                      </template>
                      <template v-slot:cell(name)="data">
                        <div
                          style="text-align: center; vertical-align: middle"
                          class="pt-0 grey-color"
                        >
                          <div class="mt-2">
                            {{ data.item.name }}
                          </div>
                        </div>
                      </template>

                      <template v-slot:cell(operation)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <v-btn
                            v-if="selectedCode != data.item"
                            @click="selectedCode = data.item"
                            height="40"
                            width="80"
                            :class="color + '-mainBtn'"
                            >انتخاب</v-btn
                          >
                          <v-btn
                            v-if="selectedCode == data.item"
                            @click="selectedCode = ''"
                            height="40"
                            class="red-mainBtn"
                            width="80"
                            >حذف</v-btn
                          >
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong>در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                    <div
                      class="d-flex flex-row justify-content-end"
                      :class="color + '-custom-pagination'"
                    >
                      <v-pagination
                        v-model="currentPage"
                        :length="Math.ceil(computedCodes.length / perPage)"
                        :total-visible="5"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                      ></v-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="px-0">
              <v-btn
                @click="
                  allCodes = orderCodes;
                  letterDetails.orderId = selectedCode.id;
                  chooseCustomerDialog = false;
                  $emit('getCodes', allCodes);
                  $emit('getId', letterDetails.orderId);
                "
                width="130"
                height="40"
                class="mt-6 float-start submit-mainBtn"
                :disabled="selectedCode && !selectedCode.code"
                >ثبت</v-btn
              >
              <v-btn
                @click="
                  search = '';
                  currentPage = 1;
                  step = 1;
                "
                width="130"
                height="40"
                class="mt-6 float-start"
                :class="color + '-mainBtn'"
                >تغییر شرکت</v-btn
              >

              <v-spacer></v-spacer>
              <v-btn
                @click="chooseCustomerDialog = false"
                width="130"
                height="40"
                class="red-borderedBtn mt-6"
                >بستن</v-btn
              >
            </v-card-actions>
          </v-window-item>
        </v-window>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from "axios";
export default {
  props: ["orderId", "orderCode", "color"],
  data() {
    return {
      step: 1,
      search: "",
      letterDetails: {
        orderId: "",
        orderCode: "",
      },
      customerNames: [],
      allCodes: [],
      orderCodes: [],
      selectedCustomer: {},
      selectedCode: {},
      gettingCodes: false,
      showSelect: false,
      gettingCustomrs: false,
      currentPage: 1,
      perPage: 4,
      chooseCustomerDialog: false,
      customersFields: [
        { key: "name", label: "نام شرکت" },
        { key: "operation", label: "انتخاب" },
      ],
      codesFields: [
        { key: "code", label: "کد استعلام" },
        { key: "operation", label: "انتخاب" },
      ],
    };
  },
  methods: {
    openDialog() {
      this.step = 1;
      this.selectedCustomer = {};
      this.selectedCode = {};
      // this.letterDetails.orderId = "";
      this.chooseCustomerDialog = true;
      this.currentPage = 1;
      this.search = "";
    },
    customerList() {
      this.gettingCustomrs = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customers/getAll",

        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.gettingCustomrs = false;
            this.customerNames = res.data;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    gettingAllCodes() {
      this.gettingCodes = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getbyCustomerFast ",
        {
          customerId: this.selectedCustomer.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.orderCodes = res.data;
          this.gettingCodes = false;
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.gettingCodes = false;
        });
    },
    nextStep() {
      this.gettingAllCodes();
      this.search = "";
      this.currentPage = 1;

      setTimeout(() => {
        this.step = 2;
      }, 200);
    },
  },
  computed: {
    computedCustomers() {
      let filtered;
      filtered = this.customerNames.filter((x) => x.name.includes(this.search));
      this.currentPage = 1;
      return filtered;
    },
    computedCodes() {
      let filtered;
      filtered = this.orderCodes.filter((x) => x.code.includes(this.search));
      this.currentPage = 1;
      return filtered;
    },
  },
  mounted() {
    this.letterDetails.orderId = this.orderId;
    this.letterDetails.orderCode = this.orderCode;
    this.customerList();
  },
};
</script>
